import { makeStyles, createStyles, Theme } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    form: {
      position: 'relative',
      marginTop: theme.spacing(2),
    },
    input: {
      display: 'block',
      padding: theme.spacing(1, 1.25),
      fontFamily: theme.typography.fontFamily,
      fontSize: 14,
      borderRadius: theme.spacing(0.75),
      border: `1px solid ${theme.extraColors.greyLight}`,
      color: theme.typography.body1.color,
      backgroundColor: theme.extraColors.greyLight,
      WebkitAppearance: 'none',
      '&::placeholder': {
        opacity: 0.75,
        color: theme.typography.body1.color,
      },
      '&:disabled': {
        userSelect: 'none',
        cursor: 'not-allowed',
      },
    },
    label: {
      display: 'block',
      cursor: 'pointer',
      fontSize: 9,
      paddingLeft: theme.spacing(1.25),
      marginBottom: theme.spacing(0.5),
    },
    cgu: {
      lineHeight: 1.4,
      display: 'block',
    },
    customCgl: {
      marginLeft: theme.spacing(4),
    },
    centeredButton: {
      textAlign: 'center',
    },
    submit: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },
    overlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background: 'rgba(255,255,255, .8)',
      backdropFilter: 'blur(2px)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
    },
    overlayIcon: {
      width: '2em',
      height: '2em',
      color: theme.palette.success.main,
    },
    hide: {
      opacity: 0,
      transition: theme.transitions.create('opacity'),
    },
    show: {
      opacity: 1,
      transition: theme.transitions.create('opacity'),
    },
    inProgress: {
      overflow: 'hidden',
      '& >span': {
        position: 'relative',
        zIndex: 2,
      },
      '&:before': {
        content: '""',
        zIndex: 1,
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        backgroundColor: theme.palette.secondary.main,
        animation: '$progress 15s forwards',
        transformOrigin: 'left',
        willChange: 'transform',
      },
    },
    '@keyframes progress': {
      '0%': {
        transform: 'scale3d(0, 1, 1)',
      },
      '20%': {
        transform: 'scale3d(0.8, 1, 1)',
      },
      '80%': {
        transform: 'scale3d(0.9, 1, 1)',
      },
      '100%': {
        transform: 'scale3d(1.1, 1, 1)',
      },
    },
  })
)

export default useStyles
